// src/mixins/index.js
// 全局混入的mixins
let mixin={
    data(){
      return{
        // 表头颜色
        headClass() {
            return "background:#f8f8f9;";
        }, 
        // careRemind:[
        //   {
        //     label:'下单提醒',
        //   },
        //   {
        //     label:'未付款提醒',
        //   },
        //   {
        //     label:'二次催付',
        //   },
        //   {
        //     label:'聚划算催付',
        //   },
        //   {
        //     label:'预售定金催付',
        //   },
        //   {
        //     label:'付款关怀',
        //   },
        //   {
        //     label:'凑单提醒',
        //   },
        //   {
        //     label:'发货提醒',
        //   },
        //   {
        //     label:'延迟发货',
        //   },
        //   {
        //     label:'物流到货',
        //   },
        //   {
        //     label:'派送提醒',
        //   },
        //   {
        //     label:'签收提醒',
        //   },
        //   {
        //     label:'宝贝关怀',
        //   },
        //   {
        //     label:'回款关怀',
        //   },
        //   {
        //     label:'申请退款',
        //   },
        //   {
        //     label:'同意退款',
        //   },
        //   {
        //     label:'拒绝退款',
        //   },
        //   {
        //     label:'退款成功',
        //   },
        //   {
        //     label:'评价关怀',
        //   },
        //   {
        //     label:'催评价',
        //   },
        //   {
        //     label:'二次催评价',
        //   },
        //   {
        //     label:'中差评安抚',
        //   },
        //   {
        //     label:'关闭前催付',
        //   },
        //   {
        //     label:'异常物流提醒',
        //   },

        // ],
        jfRules:[
          {
            text:"1、单条70个字,超过70个字将按每条67个字计算。"
          },
          {
            text:"2、一个汉字、字母、空格都按一个字计算。"
          },
          {
            text:"3、带标签的短信按实际长度计算。发送时平台自动替换。"
          },
          {
            text:"4、“签名”与“拒收请回复R”包含在字数组中。"
          },                     
        ],
        signNameList:[], // 短信签名集合
        shieldDaysList:[  //屏蔽天数集合
          {
            label:"1"
          },
          {
            label:"3"
          },
          {
            label:"5"
          },
          {
            label:"7"
          },
          {
            label:"15"
          },
          {
            label:"30"
          },                                                  
        ],
        testButLoading:false, // 短信测试Loading
      };
    },
    methods:{
      toSetSys(){
        let routeData = this.$router.resolve({ path:'/set/set-sys/set-certification'});
        window.open(routeData.href, '_blank');
      },
      // 表单校验定位
      formPosition(object){
        let str = [];
        for (let key in object) {
            object[key].map((item) => {
                str.push(item.message);
            });
            let dom = this.$refs[Object.keys(object)[0]];
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
                dom = dom[0];
                break;//结束语句并跳出语句，进行下个语句执行
            }
            // 定位代码
            dom.$el.scrollIntoView({
                block: "center",
                behavior: "smooth",
            });
        }
        // 页面提示未通过校验字段项，并以逗号分隔
        this.$message.error(str.join(","));        
      },
      // 将手机号码字符串转换成数组
      phoneStrToArr(str){
        let res = str.replace(/，/g,',').split(',')
        let phoneArr = []
        for(let i=0;i<res.length;i++){
          phoneArr.push(res[i])
        }
        return phoneArr
      },
      // 短信测试
      testSms(params){
        if(params.signName&&params.content&&params.textPhone){

          if(params.content.indexOf('{自定义变量}')>-1){
            if(params.customPlaceholder == null){
              this.$message({ message: '请设置自定义变量', type: "error" });
              return
            }
          }

          let regPhone=/^1[3|4|5|6|7|8|9][0-9]\d{8}([,|，]1[3|4|5|6|7|8|9][0-9]\d{8})*$/   // 手机号码验证
          if(params.textPhone.match(regPhone)){
            let data = {
              signature:params.signName,
              templateId:params.id,
              phoneList:this.phoneStrToArr(params.textPhone),
              plhVal:{
                customPlaceholder:params.customPlaceholder,
                shortLink:params.url, //原链接
              }
            }
            if(params.content.indexOf('{会员姓名}')>-1){
              data.plhVal.receiverName = '张三'
            }
            if(params.content.indexOf('{会员昵称}')>-1){
              data.plhVal.nick = '李四'
            }            
            this.testButLoading = true
            this.$http
                .createTestSms(data)
                .then(res=>{
                  this.testButLoading = false
                  if(res.data == 'true') {
                    this.$message({ message: '操作成功', type: "success" });
                  }else{
                    this.$message({ message: res.data, type: "error" });
                  }
                })
                .catch(err=>{
                  this.testButLoading = false
                })
          }else{
            this.$message({ message: '请填写正确的手机格式', type: "error" });
          }
        }else{
          this.$message({ message: '请将短信内容填写完整', type: "error" });
        }
      },
      // 淘宝短信签名查询
      querySignName() {
        let data = {
          status: "1",
        };        
        this.$http
            .querySignName(data)
            .then((res) => {
                //筛选出审核通过的签名
                let arr = res.data || []
                this.signNameList = arr
            })
            .catch((err) => {

            });
      },
    }
};


export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/index.js